export default __webpack_public_path__ + "media/images/gm_plus/gmplus_upgrade_tile-6fc5e92a6bccf030291d3f27191cfcaf.jpg";